export const Bin = ({ width = '17', height = '17' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_10891)">
        <path
          d="M14.3594 2.11987H11.918V1.63159C11.918 0.823877 11.2608 0.166748 10.4531 0.166748H6.54688C5.73916 0.166748 5.08203 0.823877 5.08203 1.63159V2.11987H2.64063C1.83291 2.11987 1.17578 2.777 1.17578 3.58472C1.17578 4.23342 1.59977 4.78462 2.18506 4.97668L3.05599 15.4902C3.11872 16.2434 3.75993 16.8334 4.51576 16.8334H12.4842C13.2401 16.8334 13.8813 16.2434 13.9441 15.49L14.8149 4.97664C15.4002 4.78462 15.8242 4.23342 15.8242 3.58472C15.8242 2.777 15.1671 2.11987 14.3594 2.11987ZM6.05859 1.63159C6.05859 1.36235 6.27764 1.14331 6.54688 1.14331H10.4531C10.7224 1.14331 10.9414 1.36235 10.9414 1.63159V2.11987H6.05859V1.63159ZM12.9708 15.4091C12.9499 15.6602 12.7362 15.8569 12.4842 15.8569H4.51576C4.26383 15.8569 4.0501 15.6602 4.02923 15.4094L3.17103 5.04956H13.829L12.9708 15.4091ZM14.3594 4.073H2.64063C2.37139 4.073 2.15234 3.85396 2.15234 3.58472C2.15234 3.31548 2.37139 3.09644 2.64063 3.09644H14.3594C14.6286 3.09644 14.8477 3.31548 14.8477 3.58472C14.8477 3.85396 14.6286 4.073 14.3594 4.073Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M6.54593 14.3618L6.05765 6.48416C6.04095 6.21499 5.80798 6.01027 5.5401 6.02704C5.27093 6.04373 5.06628 6.27544 5.08294 6.54458L5.57122 14.4222C5.58727 14.6811 5.80225 14.8803 6.05811 14.8803C6.34089 14.8803 6.56328 14.6421 6.54593 14.3618Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M8.5 6.02612C8.23034 6.02612 8.01172 6.24474 8.01172 6.5144V14.392C8.01172 14.6617 8.23034 14.8803 8.5 14.8803C8.76966 14.8803 8.98828 14.6617 8.98828 14.392V6.5144C8.98828 6.24474 8.76966 6.02612 8.5 6.02612Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M11.4599 6.02707C11.1913 6.01037 10.959 6.21502 10.9423 6.4842L10.454 14.3618C10.4374 14.6309 10.6421 14.8626 10.9112 14.8793C11.1805 14.896 11.4121 14.6913 11.4287 14.4222L11.917 6.54461C11.9337 6.27544 11.729 6.04373 11.4599 6.02707Z"
          fill="white"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_10891">
          <rect
            width="16.6667"
            height="16.6667"
            fill="white"
            transform="translate(0.166016 0.166748)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
